import script from "./AladinSkyMap.vue?vue&type=script&setup=true&lang=js"
export * from "./AladinSkyMap.vue?vue&type=script&setup=true&lang=js"

import "./AladinSkyMap.vue?vue&type=style&index=0&id=01876559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01876559"]])

export default __exports__